/* ==========================================================================
   GSJ: keep the Klaviyo "GET $25 OFF" teaser off the price on phones.
   (Sept 24 2026, checkout-leak fix 5)

   Klaviyo renders its teaser as a fixed tab at the bottom centre of the
   screen (inline styles: bottom 0, margin 0 130px). On a 390px phone the
   product title and price scroll straight underneath it, so for part of every
   product page scroll the price is hidden behind the offer.

   Two layers, phones only (max-width 749px); desktop is left exactly as
   Klaviyo draws it:

   1. MOVE. The tab becomes a slim vertical tab on the right edge, a little
      above the middle of the screen. Prices on this theme are left aligned,
      so the right edge is the one strip they never reach. The chat bubble
      keeps the bottom right corner to itself.

   2. GUARD. If the tab ever does overlap price text anyway (a long sale
      price, a collection card in the right column, the cart drawer's total),
      it fades out until the overlap ends, and it stays hidden while the cart
      drawer or the menu is open. Measured on the TEXT of the price, not the
      price block, so a full width block does not hide the tab for nothing.
      Event driven only: a passive scroll listener throttled to one check per
      frame, resize, and a MutationObserver for Klaviyo inserting the tab and
      for the panels opening. No continuous animation loop.

   Nothing here touches the Klaviyo form itself: tapping the tab still opens
   the same popup, and the close button still works.
   ========================================================================== */
(function () {
  'use strict';

  var MQ = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  var TEASER = '[class*="kl-teaser-"]';
  var PRICE = [
    '.ecom-product-single__price',
    '.price',
    '[class*="__price"]',
    '[class*="card-price"]',
    '[data-gs-est-total]',
    '[data-gs-subtotal]',
    '.gs-line__price'
  ].join(',');
  var HIDE = 'gsj-kl-teaser--clear';

  var css =
    '@media (max-width: 749px) {' +
      TEASER + '{' +
        'top: 38% !important; bottom: auto !important;' +
        'left: auto !important; right: 0 !important;' +
        'margin: 0 !important; width: auto !important; max-width: none !important;' +
        'transform: rotate(-90deg) !important; transform-origin: 100% 100% !important;' +
        'transition: opacity .2s ease, visibility .2s ease;' +
      '}' +
      TEASER + ' [data-testid="animated-teaser"] > span { min-height: 40px !important; padding: 6px 14px !important; }' +
      TEASER + '.' + HIDE + '{ opacity: 0 !important; visibility: hidden !important; pointer-events: none !important; }' +
    '}';

  function injectStyle() {
    if (document.getElementById('gsj-kl-teaser-style')) return;
    var s = document.createElement('style');
    s.id = 'gsj-kl-teaser-style';
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }

  function isPhone() { return MQ ? MQ.matches : window.innerWidth <= 749; }

  function rectsOverlap(a, b) {
    return a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;
  }

  /* Bounding boxes of the visible text inside an element (one per line box). */
  function textRects(el) {
    var out = [];
    try {
      var r = document.createRange();
      r.selectNodeContents(el);
      var list = r.getClientRects();
      for (var i = 0; i < list.length; i++) {
        if (list[i].width > 0 && list[i].height > 0) out.push(list[i]);
      }
    } catch (e) { /* ignore */ }
    return out;
  }

  function panelOpen() {
    var cart = window.GSCartInstance;
    if (cart && cart.core && cart.core.isOpen) return true;
    return !!document.querySelector('.gs-panel[aria-hidden="false"]');
  }

  function check() {
    var teaser = document.querySelector(TEASER);
    if (!teaser) return;
    if (!isPhone()) { teaser.classList.remove(HIDE); return; }
    var hide = panelOpen();
    if (!hide) {
      var tr = teaser.getBoundingClientRect();
      if (tr.width > 0 && tr.height > 0) {
        var prices = document.querySelectorAll(PRICE);
        for (var i = 0; i < prices.length && !hide; i++) {
          var br = prices[i].getBoundingClientRect();
          if (!br.width || !rectsOverlap(tr, br)) continue; // cheap block test first
          if (!/\d/.test(prices[i].textContent || '')) continue;
          var rs = textRects(prices[i]);
          for (var j = 0; j < rs.length; j++) {
            if (rectsOverlap(tr, rs[j])) { hide = true; break; }
          }
        }
      }
    }
    teaser.classList.toggle(HIDE, hide);
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () { queued = false; check(); });
  }

  function init() {
    injectStyle();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    if (MQ && MQ.addEventListener) MQ.addEventListener('change', schedule);
    if (window.MutationObserver) {
      /* Klaviyo mounts the teaser late (after its display delay), and the cart
         drawer / menu flip aria-hidden when they open. Both land here. */
      /* Two observers: observe() on the same node twice would replace the
         first set of options rather than add to it. */
      new MutationObserver(schedule).observe(document.body, { childList: true });
      new MutationObserver(schedule).observe(document.body,
        { subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
    }
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
